export default "__VITE_ASSET__DhqaFeYi__"